export type PostCats =
  | 'humans'
  | 'people'
  | 'health'
  | 'philosophy'
  | 'wisdom'
  | 'media'

  | 'history'
  | 'investigation'
  | 'journalism'
  | 'blog'
  | 'finance'
  | 'education'

  | 'power'
  | 'security'
  | 'authority'
  | 'politics'
  | 'feudalism'
  | 'globalism'

  | 'science'
  | 'architecture'
  | 'technology'
  | 'electronics'
  | 'engineering'
  | 'robotics'

  | 'spirituality'
  | 'religion'
  | 'institution'
  | 'intelligence'
  | 'space'
  | 'aliens'

  | 'meme'
  | 'trope'
  | 'opinion'
  | 'literature'
  | 'law'
  | 'justice'

  | 'music'
  | 'comedy'
  | 'art'
  | 'story'
  | 'film'
  | 'gaming'

  | 'timeline'
  | 'future'
  | 'organisation'
  | 'agriculture'
  | 'hardware'
  | 'software'

  | 'symbology'
  | 'mystery'
  | 'secret'
  | 'conspiracy'
  | 'supernatural'
  | 'satire'

  | 'psychology'
  | 'community'
  | 'place'
  | 'travel'
  | 'national'
  | 'ideology'

  | 'energy'
  | 'life'
  | 'nature'
  | 'food'
  | 'animal'
  | 'weather'

  | 'miscellaneous'

export type SysCats = 'relation' | 'video' | 'playlist' | 'link'

export type Cats = PostCats | SysCats

export interface CatData {
  val: Cats
  icon: string // @mui lib icons
  altIcon?: string // Native mui icons
  alias?: string
  modifier?: string
  disabled?: boolean
  relatedCats?: Cats[]
}

const categories: CatData[] = [
  {
    val: 'humans',
    alias: 'humanity',
    modifier: 'human',
    icon: 'pan_tool',
    altIcon: 'hand-back-right',
    relatedCats: ['people']
  },
  {
    val: 'people',
    icon: 'self_improvement',
    altIcon: 'meditation',
    relatedCats: ['humans']
  },
  {
    val: 'health',
    // modifier: 'healthy',
    icon: 'local_hospital',
    altIcon: 'hospital-box',
    relatedCats: ['wisdom', 'philosophy', 'science']
  },
  {
    val: 'philosophy',
    modifier: 'philosophical',
    icon: 'volunteer_activism',
    altIcon: 'hand-heart',
    relatedCats: ['wisdom']
  },
  {
    val: 'wisdom',
    icon: 'spa',
    relatedCats: ['philosophy']
  },
  {
    val: 'media',
    icon: 'tv',
    altIcon: 'television',
    relatedCats: ['blog', 'art', 'film', 'music', 'gaming']
  },


  {
    val: 'history',
    modifier: 'historic',
    icon: 'account_balance',
    altIcon: 'bank',
    relatedCats: ['education']
  },
  {
    val: 'investigation',
    alias: 'investigations',
    modifier: 'investigational',
    icon: 'fingerprint',
    relatedCats: ['journalism']
  },
  {
    val: 'journalism',
    alias: 'news',
    modifier: 'journalist',
    icon: 'public',
    altIcon: 'earth',
    relatedCats: ['investigation']
  },
  {
    val: 'blog',
    alias: 'blogs',
    icon: 'rss_feed',
    altIcon: 'rss',
    relatedCats: ['journalism', 'media']
  },
  {
    val: 'finance',
    alias: 'money',
    modifier: 'financial',
    icon: 'payments',
    altIcon: 'cash-multiple',
    relatedCats: ['power', 'globalism', 'journalism']
  },
  {
    val: 'education',
    icon: 'school',
    relatedCats: ['history']
  },


  {
    val: 'power',
    icon: 'square_foot',
    altIcon: 'set-square',
    relatedCats: ['politics', 'security', 'authority', 'feudalism', 'globalism', 'journalism']
  },
  {
    val: 'security',
    icon: 'security',
    relatedCats: ['power', 'authority', 'politics']
  },
  {
    val: 'authority',
    icon: 'local_police',
    altIcon: 'police-badge',
    relatedCats: ['power', 'security', 'politics']
  },
  {
    val: 'politics',
    icon: 'policy',
    modifier: 'political',
    altIcon: 'shield-search',
    relatedCats: [
      'journalism',
      'authority',
      'feudalism',
      'globalism'
    ]
  },
  {
    val: 'feudalism',
    icon: 'qr_code',
    altIcon: 'qrcode',
    relatedCats: ['politics']
  },
  {
    val: 'globalism',
    icon: 'language',
    modifier: 'globalist',
    altIcon: 'web',
    relatedCats: ['politics']
  },


  {
    val: 'science',
    alias: 'knowledge',
    modifier: 'scientific',
    icon: 'biotech ',
    altIcon: 'microscope',
    relatedCats: [
      'technology',
      'engineering',
      'robotics',
      'electronics'
    ]
  },
  {
    val: 'architecture',
    icon: 'castle',
    relatedCats: ['engineering', 'science', 'history']
  },
  {
    val: 'technology',
    icon: 'nfc',
    // modifier: 'technological',
    relatedCats: [
      'science',
      'engineering',
      'robotics',
      'electronics'
    ]
  },
  {
    val: 'electronics',
    alias: 'hardware',
    modifier: 'electronic',
    icon: 'mouse',
    relatedCats: [
      'science',
      'technology',
      'engineering',
      'robotics'
    ]
  },
  {
    val: 'engineering',
    icon: 'engineering',
    altIcon: 'account-hard-hat',
    relatedCats: [
      'science',
      'technology',
      'robotics',
      'electronics'
    ]
  },
  {
    val: 'robotics',
    modifier: 'robotic',
    icon: 'precision_manufacturing',
    altIcon: 'robot-industrial',
    relatedCats: [
      'engineering',
      'technology',
      'electronics',
      'science'
    ]
  },


  {
    val: 'spirituality',
    icon: 'front_hand',
    altIcon: 'hand-front-right',
    relatedCats: ['religion']
  },
  {
    val: 'religion',
    icon: 'church',
    modifier: 'religious',
    relatedCats: ['spirituality']
  },
  {
    val: 'institution',
    icon: 'location_city',
    altIcon: 'city',
    relatedCats: ['politics', 'education']
  },
  {
    val: 'intelligence',
    icon: 'auto_stories',
    altIcon: 'book-open-page-variant',
    relatedCats: [
      'education',
      'science',
      'philosophy',
      'wisdom'
    ]
  },
  {
    val: 'space',
    icon: 'rocket_launch',
    altIcon: 'rocket-launch',
    relatedCats: [
      'aliens',
      'science',
      'technology'
    ]
  },
  {
    val: 'aliens',
    icon: 'man_3',
    altIcon: 'human-male',
    relatedCats: ['space']
  },


  {
    val: 'meme',
    alias: 'memes',
    modifier: 'memetic',
    icon: 'psychology_alt',
    altIcon: 'head-question',
    relatedCats: [
      'trope',
      'opinion',
      'satire',
      'comedy',
    ]
  },
  {
    val: 'trope',
    alias: 'tropes',
    icon: 'nature_people',
    altIcon: 'nature-people',
    relatedCats: ['meme']
  },
  {
    val: 'opinion',
    alias: 'subjective',
    modifier: 'opinionated',
    icon: 'record_voice_over',
    altIcon: 'account-voice',
    relatedCats: [
      'humans',
      'philosophy',
      'wisdom',
      'community'
    ],
  },
  {
    val: 'literature',
    icon: 'local_library',
    altIcon: 'library',
    relatedCats: ['education', 'story']
  },
  {
    val: 'law',
    icon: 'gavel',
    relatedCats: ['justice']
  },
  {
    val: 'justice',
    icon: 'balance',
    altIcon: 'scale-balance',
    relatedCats: ['law']
  },


  {
    val: 'music',
    modifier: 'musical',
    icon: 'music_note',
    // icon: 'audiotrack',
    altIcon: 'music',
    relatedCats: ['art']
  },
  {
    val: 'comedy',
    modifier: 'comedic',
    icon: 'mood',
    altIcon: 'emoticon-outline',
    relatedCats: ['satire']
  },
  {
    val: 'art',
    modifier: 'artistic',
    icon: 'palette',
    relatedCats: [
      'music',
      'story',
      'film',
      'gaming'
    ]
  },
  {
    val: 'story',
    alias: 'stories',
    icon: 'menu_book',
    altIcon: 'book-open-variant',
    relatedCats: [
      'film',
      'gaming',
      'literature'
    ]
  },
  {
    val: 'film',
    alias: 'movies',
    icon: 'theaters',
    altIcon: 'filmstrip',
    relatedCats: ['story']
  },
  {
    val: 'gaming',
    alias: 'games',
    icon: 'sports_esports',
    // icon: 'videogame_asset'
    altIcon: 'controller',
    relatedCats: ['story', 'art']
  },


  {
    val: 'timeline',
    icon: 'date_range',
    altIcon: 'calendar-range',
    relatedCats: ['history', 'future']
  },
  {
    val: 'future',
    icon: 'elderly',
    altIcon: 'human-cane',
    relatedCats: [
      'robotics',
      'space',
      'technology'
    ]
  },
  {
    val: 'organisation',
    alias: 'organisations',
    modifier: 'organisational',
    icon: 'domain',
    altIcon: 'domain',
    relatedCats: ['institution', 'politics']
  },
  {
    val: 'agriculture',
    icon: 'agriculture',
    altIcon: 'tractor-variant',
    relatedCats: ['nature']
  },
  {
    val: 'hardware',
    alias: 'apps',
    icon: 'developer_board',
    altIcon: 'developer-board',
    relatedCats: ['technology', 'electronics']
  },
  {
    val: 'software',
    alias: 'apps',
    icon: 'terminal',
     altIcon: 'console',
    relatedCats: ['hardware', 'technology', 'electronics']
  },


  {
    val: 'symbology',
    alias: 'logos',
    modifier: 'symbolic',
    icon: 'shield',
    relatedCats: ['art', 'mystery']
  },
  {
    val: 'mystery',
    alias: 'mysteries',
    modifier: 'mysterious',
    icon: 'meeting_room',
    altIcon: 'door-closed',
    relatedCats: ['symbology', 'secret', 'conspiracy', 'supernatural', 'spirituality']
  },
  {
    val: 'secret',
    alias: 'secrets',
    modifier: 'secretive',
    icon: 'vpn_key',
    altIcon: 'key',
    relatedCats: [
      'mystery',
      'conspiracy',
      'supernatural'
    ]
  },
  {
    val: 'conspiracy',
    alias: 'what',
    modifier: 'conspiratorial',
    icon: 'coronavirus',
    altIcon: 'virus',
    relatedCats: [
      'mystery',
      'secret',
      'supernatural'
    ]
  },
  {
    val: 'supernatural',
    icon: 'auto_awesome',
    altIcon: 'creation',
    relatedCats: ['mystery', 'spirituality']
  },
  {
    val: 'satire',
    modifier: 'satirical',
    icon: 'child_care',
    altIcon: 'baby-face-outline',
    relatedCats: ['meme', 'opinion']
  },


  {
    val: 'psychology',
    icon: 'psychology',
    altIcon: 'head-cog',
    relatedCats: ['humans', 'community']
  },
  {
    val: 'community',
    alias: 'communities',
    icon: 'groups',
    // icon: 'deck'
    altIcon: 'account-group',
    relatedCats: ['psychology']
  },
  {
    val: 'place',
    alias: 'places',
    modifier: 'physical', // icw location? :S
    icon: 'place',
    altIcon: 'map-marker',
    relatedCats: ['community']
  },
  {
    val: 'travel',
    modifier: 'traveling',
    icon: 'explore',
    altIcon: 'compass',
    relatedCats: ['place', 'community']
  },
  {
    val: 'national',
    icon: 'flag',
    relatedCats: ['politics', 'community']
  },
  {
    val: 'ideology',
    icon: 'lightbulb',
    relatedCats: ['politics', 'community']
  },


  {
    val: 'energy',
    alias: 'power',
    modifier: 'energic',
    icon: 'bolt',
    altIcon: 'lightning-bolt',
    relatedCats: ['technology', 'science']
  },
  {
    val: 'nature',
    // modifier: 'natural',
    icon: 'forest',
    relatedCats: ['life', 'agriculture']
  },
  {
    val: 'life',
    icon: 'local_fire_department',
    altIcon: 'fire',
    relatedCats: ['nature', 'animal']
  },
  {
    val: 'food',
    icon: 'local_pizza',
    altIcon: 'pizza',
    relatedCats: ['agriculture']
  },
  {
    val: 'animal',
    alias: 'animals',
    modifier: 'animalistic',
    icon: 'pets',
    altIcon: 'paw',
    relatedCats: ['life', 'nature']
  },
  {
    val: 'weather',
    alias: 'climate',
    icon: 'storm',
    altIcon: 'weather-hurricane-outline',
    relatedCats: ['nature']
  },

  {
    val: 'miscellaneous',
    alias: 'misc',
    icon: 'pentagon',
    // icon: 'workspaces',
    // altIcon: 'google-circles-communities'
  },
] as const

// Non-user choosable categories
export const sysCats: CatData[] = [
  {
    val: 'relation',
    icon: 'swipe_right_alt',
    altIcon: 'ray-start-arrow'
  },
  {
    val: 'video',
    icon: 'play_circle',
    altIcon: 'play-circle'
  },
  {
    val: 'playlist',
    icon: 'playlist_play',
    altIcon: 'playlist-play'
  },
  {
    val: 'link',
    icon: 'link',
  },
]

export const allCats = [...categories, ...sysCats]

export const allCatsArray: Cats[] = allCats.map((cat) =>
  cat.val)

export const allSysCatsArray: Cats[] = sysCats.map((cat) =>
  cat.val)

export default categories
